/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const salesApi = {
    // 제품 주문(set goods order)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-goods
    salesGoodsOrder(params) {
        return httpService.post(`/sales/order/goods/${params.goodsId}`)
    },

    // 최근 주문자 정보(Recent Order Information)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-orderer-info-recent
    salesOrdererRecent() {
        return httpService.get(`/sales/order/orderer/recent`)
    },   

    // 구매 주문 조회(get purchase order)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-goods-purchased-fetch
    salesGoodsPurchased(params) {
        return httpService.get(`/sales/order/purchased`, params)
    },

    // 제품 주문 Micro (set goods order)
    salesMicroGoodsOrder(params) {
        return httpService.post(`/micro/sales/order/goods/${params.goodsId}`)
    },

    // 구매 주문 조회 Micro (get purchase order)
    salesMicroGoodsPurchased(params) {
        return httpService.get(`/micro/sales/order/goods/${params.goodsId}/purchased`)
    },

    // 주문 상세(get order detail information)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-detail
    salesOrderResult(params) {
        return httpService.get(`/sales/order/${params.paymentId}`)
    },

    // 결제 요청(request payment)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-pay-request
    salesRequestPayment(params) {
        return httpService.post(`/sales/order/${params.orderId}/pay`, params)
    },

   
    // Credit 카드 목록 조회(get card list)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-fetch-page
    salesCreditcardList(params) {
        return httpService.get(`/sales/creditcard`)
    },

    // 카드 등록(regist card)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-register
    salesCreditcardInsert(params) {
        return httpService.post(`/sales/creditcard`, params)
    },

    // 카드 삭제(delete card)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-remove
    salesCreditcardDelete(params) {
        return httpService.delete(`/sales/creditcard/${params.id}`)
    },

    // 은행 목록 조회(get country list)
    // 
    salesRefundCountryList(params) {
        return httpService.get(`/codes/code/CURRENCY`)
    },

    // 은행 목록 조회(get bank list)
    // 
    salesRefundBankList(params) {
        return httpService.get(`/codes/code/BANK_CODE`)
    },

    // 환불 요청 목록 조회(Inquire refund request list)
    // https://dev.clp.kr/spc/api/static/docs/sales_refund.html#resources-sales-refund-list
    refundOrderList(params) {
        return httpService.get(`/sales/refund/list`, params)
    },
    
    // 환불 요청(request refund)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-request
    selesRefundRequest(params) {
        return httpService.post(`/sales/refund`, params)
    },

    // 환불 요청 정보 수정(update refund information)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-information-change
    selesRefundUpdate(params) {
        return httpService.put(`/sales/refund`, params)
    },

    // 결제 방법 목록(get payment method list)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-installed-payment-method
    salesPaymentMethodList(params) {
        return httpService.get(`/sales/order/paymentmethod`,params)
    },

    // 구매목록(get purchase list)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-purchase-page
    salesOrderList(params) {
        return httpService.get(`/sales/order`, params)
    },

    // 주문 상세(get order detail information)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-detail
    salesOrderDetail(params) {
        return httpService.get(`/sales/order/${params.orderId}`)
    },

    // 주문 상세(get refund detail information)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-detail
    salesRefundDetail(params) {
        return httpService.get(`/sales/refund/${params.orderId}`)
    },
    

    // 환불 1:1 문의 조회(get refund FAQ list)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-board-fetch
    salesQnAList(params) {
        return httpService.get(`/sales/refund/board`, params)
    },

    // 환불 1:1 문의 등록(regist refund FAQ)
    // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-board-register
    salesQnAWrite(params) {
        return httpService.post(`/sales/refund/board`, params)
    }, 
    
    // 결제 대기중인 상품을 구매 취소하는 API입니다.(cancel the order)
    // https://dev.clp.kr/gck/api/static/docs/sales_purchase.html#resources-sales-order-cancel
    selesRequestRefund(params) {
        return httpService.delete(`/sales/order/${params.orderId}`)
    },
}

// export const 
export default salesApi